import {
  TASK_STATES, TASKS_DOCUMENTS_MODAL, TASKS_DOCUMENTS_UPDATE, TASKS_ERROR, TASKS_ERROR_DOCUMENTS, TASKS_LOADING,
  TASKS_UPDATE, TASKS_UPDATE_ACTIVE, TASKS_UPDATE_MONTHLY_TASK, TASKS_UPDATE_STATE, TASKS_UPDATE_TASK, TASKS_WORK_CHECKS_MODAL
} from "../actions/tasksActions";

const INITIAL_STATE = {
  tasks: [],
  tasksPagination: null,
  tasksLoading: false,
  tasksError: null,

  taskStates: [],

  taskActive: null,

  taskMonthly: null,

  tasksDocumentsModal: false,
  tasksDocumentsModalTitle: '',
  tasksDocumentsModalSubtitle: '',
  tasksDocumentsModalDate: '',
  tasksDocumentsModalBuild: '',
  tasksDocumentsError: null,
  tasksDocuments: [],

  tasksWorkChecksModal: false,
  tasksWorkChecksModalTitle: '',
  tasksWorkChecksModalSubtitle: '',
  tasksWorkChecksModalDate: '',
  tasksWorkChecksModalBuild: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TASKS_UPDATE:
      return {
        ...state,
        tasks: action.payload.data,
        tasksPagination: action.payload.pagination,
        tasksError: action.payload.message,
      };
    case TASKS_ERROR:
      return { ...state, tasksError: action.payload };
    case TASKS_LOADING:
      return {...state, tasksLoading: action.payload };

    case TASKS_UPDATE_TASK:
      const tasksUpdated = state.tasks.map((task) => {
        if (task.id === action.id) {
          return action.payload;
        }
        return task;
      });
      return {
        ...state,
        tasks: [...tasksUpdated],
      };

    case TASKS_UPDATE_STATE:
      const tasks = state.tasks.map((task) => updateTaskState(task, action.id, action.payload.data));
      return {
        ...state,
        tasks: [...tasks],
      };

    case TASK_STATES:
      return {
        ...state,
        taskStates: [...action.payload.data],
      };

    case TASKS_UPDATE_ACTIVE:
      return {
        ...state,
        taskActive: action.payload,
      };

    /* WORK CHECKS */

    case TASKS_WORK_CHECKS_MODAL:
      return {
        ...state,
        tasksWorkChecksModal: action.payload,
        tasksWorkChecksModalTitle: action.title,
        tasksWorkChecksModalSubtitle: action.subtitle,
        tasksWorkChecksModalDate: action.date,
        tasksWorkChecksModalBuild: action.build,
      };

    case TASKS_UPDATE_MONTHLY_TASK:
      return {
        ...state,
        taskMonthly: action.payload,
      };

    /* DOCUMENTS */

    case TASKS_DOCUMENTS_MODAL:
      return {
        ...state,
        tasksDocumentsModal: action.payload,
        tasksDocumentsModalTitle: action.title,
        tasksDocumentsModalSubtitle: action.subtitle,
        tasksDocumentsModalDate: action.date,
        tasksDocumentsModalBuild: action.build,
      };
    case TASKS_DOCUMENTS_UPDATE:
      return {
        ...state,
        tasksDocuments: action.payload.data,
      };
    case TASKS_ERROR_DOCUMENTS:
      return { ...state, tasksErrorDocuments: action.payload };

    default:
      return state;
  }
};


const updateTaskState = (task, id, taskUpdate) => {
  const newTask = {...task};
  if (task.id === id) {
    newTask.task_state = taskUpdate.task_state;
  }
  return newTask;
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/reducers/TasksReducer.js